import { gql, TypedDocumentNode } from '@apollo/client'

import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { DOMAIN_BIDDER_SCHEMA_FRAGMENT } from './fragments/domainBidderSchema'
import { Data, Variables } from './types'

export const GET_DOMAIN_BIDDER: TypedDocumentNode<Data, Variables> = gql`
  ${ALERT_FRAGMENT}
  ${DOMAIN_BIDDER_SCHEMA_FRAGMENT}

  query getDomainBidder($id: ID!) {
    node(id: $id) {
      ... on DomainBidder {
        id
        domain {
          activeAbTest {
            id
          }
          alerts {
            ...AlertFragment
          }
          id
          name
        }
        csEnabled
        csSchema {
          ...DomainBidderSchemaFragment
        }
        fieldAlerts {
          ...AlertFragment
        }
        priority
        s2sEnabled
        s2sSchema {
          ...DomainBidderSchemaFragment
        }
        workspaceBidder {
          id
          priority
          bidder {
            id
            s2sAvailable
          }
          status
        }
      }
    }
  }
`
